import { Button, Input, InputGroup, Label } from 'reactstrap'
import { firstLetter } from 'common'
import React from 'react'
import useTranslation from '../hooks/UseTranslation'
import { getAxiosParams, postMessage } from '../utils/client'
import GuruModal from './GuruModal'
import AsyncButton from './AsyncButton'
import { UserContext } from 'contexts/UserContext'
import { useRouter } from 'next/router'
import { InboxApi } from 'typescript-axios'

const INBOX_SERVICE = new InboxApi(getAxiosParams())
const NewMessageModal = (props) => {
  const { t } = useTranslation()
  const [content, setContent] = React.useState('')
  const [msgOutput, setMsgOutput] = React.useState(null)

  const onFinish = () => {
    setContent('')
    if (props.onFinish) {
      props.onFinish()
    }
  }

  const onSubmit = async () =>
    postMessage({ content, targetId: props.user?.id }).then(onFinish)

  const onEnterPress = (e) => {
    // fixme somehow e.keyCode == 0 on enter...
    if ((e.keyCode == 13 || e.which == 13) && e.shiftKey == false) {
      onSubmit(e)
      e.preventDefault()
    }
  }

  return (
    <GuruModal
      isOpen={props.isOpen}
      toggle={props.toggle}
      hideFooter
      title={firstLetter(
        t('new_message_modal_title', props.user?.firstname ?? '')
      )}
    >
      <InputGroup>
        <Label for='message' className='form-label'>
          {props.title}
        </Label>
        <Input
          // onKeyPress={onEnterPress}
          rows={5}
          type='textarea'
          name='message'
          id='new_message_input_id'
          placeholder={t('new_message_modal_hint')}
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
      </InputGroup>
      <div className='mt-3 text-right'>
        <Button className='mr-2' color='light' onClick={props.toggle}>
          {t('cancel')}
        </Button>
        <AsyncButton disabled={!content} color='primary' onClick={onSubmit}>
          <i className='fa fa-paper-plane fa-fw mr-2' />
          {t('new_message_modal_button')}
        </AsyncButton>
      </div>
    </GuruModal>
  )
}

export default NewMessageModal

export const NewMessageButton = ({ targetUser }) => {
  const { loggedUser } = React.useContext(UserContext)
  const isOwner = loggedUser?.id === targetUser?.id
  const [newMessageTarget, setNewMessageTarget] = React.useState(null)
  const [newMessageLoading, setNewMessageLoading] = React.useState(false)
  const router = useRouter()

  const startNewMessage = () => {
    if (newMessageLoading) return
    setNewMessageLoading(true)
    INBOX_SERVICE.getChatWithUserApiV1InboxWithUserGet(targetUser.id)
      .then((res) => {
        router.push('/inbox/[id]', `/inbox/${res.data.id}`)
      })
      .catch(() => setNewMessageTarget(targetUser))
      .finally(() => setNewMessageLoading(false))
  }

  return (
    <>
      {newMessageTarget !== null && (
        <NewMessageModal
          isOpen={newMessageTarget !== null}
          toggle={() => setNewMessageTarget(null)}
          user={newMessageTarget}
          onFinish={() => setNewMessageTarget(null)}
        />
      )}
      {!isOwner && (
        <Button color='link' onClick={() => startNewMessage()}>
          <i className='fa fa-paper-plane text-lg' />
        </Button>
      )}
    </>
  )
}
